// @ts-ignore
import TrieSearch, { TrieSearchOptions } from 'trie-search';
import { distinctBy } from './distinctBy';


export class Trie<T> {
  private _trie: TrieSearch<T>;

  constructor(options: TrieSearchOptions<T>) {
    let tireSearchConfig: TrieSearchOptions<T> = {
      ...options,
      expandRegexes: [],
    };

    this._trie = new TrieSearch(undefined, tireSearchConfig);
  }

  add(key: string, item: T) {
    this._trie.map(key, item);
  }

  search(phrases: string | string[], limit?: number): T[] {
    return this._trie.search(phrases, undefined, limit);
  }

  searchDistinct(phrases: string | string[], by: (item: T) => any, limit?: number) {
    return distinctBy(this.search(phrases, limit), by);
  }
}
 